﻿var count = 0;

export default function (name, prefix = 0) {
    count++;

    return new Id(`${prefix}-${name || ""}-${count}`);
}

function Id(id) {
    this.id = id;
    this.href = new URL(`#${id}`, document.location) + "";
}

Id.prototype.toString = function () {
    return "url(" + this.href + ")";
};